import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "input",
    "list",
    "option",
    "hiddenFields",
    "tagsContainer",
    "noResults",
  ]

  connect() {
    this.selectedIds = new Set()
    this.initializeSelectedValues()
    this.boundCloseIfClickedOutside = this.closeIfClickedOutside.bind(this)
    document.addEventListener("click", this.boundCloseIfClickedOutside, true)
    this.isOpen = false
  }

  disconnect() {
    document.removeEventListener("click", this.boundCloseIfClickedOutside, true)
  }

  initializeSelectedValues() {
    const preselectedIds = this.inputTarget.dataset.selectedIds
    if (preselectedIds) {
      const ids = preselectedIds.split(",")
      ids.forEach(id => {
        const option = this.optionTargets.find(o => o.dataset.id === id)
        if (option) {
          const name = option.dataset.name
          this.select(id, name, { silent: true })
        }
      })
    }
  }

  open() {
    if (this.isOpen) {
      this.close()
      return
    }

    this.listTarget.classList.remove("hidden")
    this.isOpen = true
  }

  close() {
    this.listTarget.classList.add("hidden")
    this.isOpen = false
  }

  closeIfClickedOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
  filter() {
    if (!this.isOpen) this.open()
    const query = this.inputTarget.value.toLowerCase()
    let anyVisible = false

    this.optionTargets.forEach(option => {
      const isVisible = option.dataset.name.toLowerCase().includes(query)
      option.classList.toggle("hidden", !isVisible)
      if (isVisible) anyVisible = true
    })

    this.noResultsTarget.classList.toggle("hidden", anyVisible)
  }

  toggleSelection(event) {
    const option = event.currentTarget
    const id = option.dataset.id
    const name = option.dataset.name

    if (this.selectedIds.has(id)) {
      this.deselect(id)
    } else {
      this.select(id, name)
    }
  }

  select(id, name, { silent = false } = {}) {
    if (this.selectedIds.has(id)) return
    this.selectedIds.add(id)

    const option = this.optionTargets.find(o => o.dataset.id === id)
    option?.classList.remove("text-gray-900")
    const checkmark = option.querySelector("[data-combobox-target='checkmark']")
    checkmark?.classList.remove("hidden")

    const hiddenInput = document.createElement("input")
    hiddenInput.type = "hidden"
    hiddenInput.name = this.inputTarget.dataset.name
    hiddenInput.value = id
    hiddenInput.dataset.id = id
    this.hiddenFieldsTarget.appendChild(hiddenInput)

    const tag = document.createElement("span")
    tag.className = "inline-flex items-center gap-x-1 rounded-full bg-blue-100 px-2 py-1 text-xs font-medium text-blue-700"
    tag.dataset.id = id
    tag.innerHTML = `
      ${name}
      <button type="button" data-action="click->combobox#removeTag" data-id="${id}" class="ml-1 rounded-full hover:bg-blue-200 p-0.5">
        &times;
      </button>
    `
    this.tagsContainerTarget.appendChild(tag)

    if (!silent) {
      this.inputTarget.value = ""
      this.filter()
      this.inputTarget.focus()
    }
  }
  
  toggle() {
    this.isOpen ? this.close() : this.open()
  }

  deselect(id) {
    this.selectedIds.delete(id)

    const option = this.optionTargets.find(o => o.dataset.id === id)
    option?.classList.remove("text-white", "bg-indigo-600")
    option?.classList.add("text-gray-900")

    const checkmark = option.querySelector("[data-combobox-target='checkmark']")
    checkmark?.classList.add("hidden")

    this.hiddenFieldsTarget.querySelector(`input[data-id="${id}"]`)?.remove()
    this.tagsContainerTarget.querySelector(`span[data-id="${id}"]`)?.remove()
  }

  removeTag(event) {
    const id = event.currentTarget.dataset.id
    this.deselect(id)
  }
}
